import {
    TEXT_ANCHOR_START,
    DOMINANT_BASELINE_MIDDLE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import {
    TEXT_COLOR,
} from '%paysera_seat_selection/js/seatSelection/config/defaults';

export default {
    text: null,
    textAnchor: TEXT_ANCHOR_START,
    dominantBaseline: DOMINANT_BASELINE_MIDDLE,
    manual: false,
    compiled: {
        x: 0,
        y: 0,
        color: TEXT_COLOR,
        text: {
            x: 0,
            y: 0,
            offset: {
                x: 0,
                y: 0,
            },
        },
    },
    transformation: {
        rotation: 0,
    },
    icon: null,
    visible: true,
};
